import { userService } from '../services'

export default () => {
	return new Promise((resolve, reject) => {
		userService.getCurrent()
			.then(response => resolve(response.data.user))
			.catch(() => reject({ error: true }))
	})
}
